import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

export { useStyles };
